import React from 'react';
import { useSelector } from 'react-redux';

import Header from '@/views/components/Header/Header';
import Footer from '@/views/components/Footer/Footer';

import TemplatesMetricsList from '@/views/pages/TemplatesManagement/TemplatesMetricsList';
import TemplatesFonts from '@/views/pages/TemplatesManagement/TemplatesFonts';

import styles from '@/views/pages/TemplatesManagement/TemplatesManagement.module.scss';

const TemplatesManagement = () => {
	const { dict } = useSelector((state) => state.app);

	return (
		<div className={ styles['templates-management__wrapper'] }>
			<Header narrow={ false } />
			<section className={ styles['templates-management__top'] }>
				<h1 className={ styles['templates-management__top__header'] }>{ dict.templatesManagement.title }</h1>
				<p className={ styles['templates-management__top__description'] }>{ dict.templatesManagement.description }</p>
				<TemplatesMetricsList />
				<TemplatesFonts />
			</section>
			<Footer narrow={ false } />
		</div>
	);
};
export default React.memo(TemplatesManagement);